import Model from './model.js';

export default class Contact extends Model
{
    constructor(id, personId, phoneNumber, phoneStatus, whatsAppStatus, telegramStatus){ 
        super()
        this.id             = id ?? 0;
        this.personId       = personId;
        this.phoneNumber    = phoneNumber;
        this.phoneStatus    = phoneStatus;
        this.whatsAppStatus  = whatsAppStatus;
        this.telegramStatus = telegramStatus;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        return {
            phoneNum:       this.phoneNumber ?? null,
            phoneStatus:    this.phoneStatus ?? null,
            whatAppStatus:  this.whatsAppStatus?.value ?? null,
            telegramStatus: this.telegramStatus?.value ?? null
        };
    }

    mapToCreate(){
        let data = this.mapToUpdate();
        data.personId = this.personId ?? null;
        return data;
    }
}

